<template>
  <div class="master-table-type">
    <el-table
      :fit="true"
      width="100%"
      :data="result"
      v-show="isShow">

      <!--  タイトル -->
      <el-table-column class-name="col-3">
        <template slot="header">
          <div style="display: flex;">
            <span>{{ $t('label.system.option.title') }}</span>
            <img
              src="@/assets/icon/bt_filter_on_off.svg"
              class="filter-style"
              @click="sortData('optionTitle')"/>
          </div>
        </template>
        <template slot-scope="scope">
          <span class="span-margin-left">{{ scope.row.optionTitle }}</span>
        </template>
      </el-table-column>

      <!--  説明 -->
      <el-table-column class-name="col-5">
        <template slot="header">
          <div style="display: flex;">
            <span>{{ $t('label.system.option.explanation') }}</span>
            <img
              src="@/assets/icon/bt_filter_on_off.svg"
              class="filter-style"
              @click="sortData('optionRemark')"/>
          </div>
        </template>
        <template slot-scope="scope">
          <span class="span-margin-left">{{ scope.row.optionRemark }}</span>
        </template>
      </el-table-column>

      <!--  照会バータン  -->
      <!-- <el-table-column class-name="col-2">
        <div slot-scope="scope" class="detail-button with-100">
          <sp-smart-button
            @click="handleEditAction(scope.row)"
            class="detailed-but with-100">
              {{$t('button.common.data.edit')}}
            </sp-smart-button>
        </div>
      </el-table-column> -->

      <!--  削除バータン  -->
      <el-table-column class-name="col-2" class="text-right">
        <!-- <div slot-scope="scope" v-auth="{ auth: '010318'}" class="text-center"> -->
        <div slot-scope="scope" class="text-center" style="display: flex;" v-auth="{ auth: '010318'}">
          <!--  照会バータン  -->
          <sp-smart-button
            @click="handleEditAction(scope.row)"
            class="detailed-but with-100">
            {{$t('button.common.data.edit')}}
          </sp-smart-button>

          <el-popconfirm
            popper-class="iot-pop-confirm"
            :title="$t('message.system.owner.deleteConfirm')"
            :confirmButtonText="$t('button.common.ok')"
            :cancelButtonText="$t('button.common.cancel')"
            class="btn-operate"
            @onConfirm="handleDeleteAction(scope.row)">
            <sp-smart-button
              v-show="!scope.row.deleteFlag"
              slot="reference">
              {{$t("button.common.data.delete")}}
            </sp-smart-button>
          </el-popconfirm>
        </div>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import SpSmartButton from "@/components/common/sp-smart-button"
const EVENT_EDIT = "on-edit"
// const EVENT_DETAIL = "on-detail"
const EVENT_DELETE = "on-delete"

export default {
  name: "BuilingSearchResultBeautify",
  components:{
    SpSmartButton: SpSmartButton
  },
  data() {
    return {
      commands: {
        FUNCTION_SETUP: 1,
        ELV_DETAIL: 2,
        DATE_FUNCTION: 3
      },
      sequence: "asc"
    }
  },
  props: {
    result: Array,
    isShow: Boolean
  },
  methods: {
    //照会バータン
    // handleDetailAction(owner) {
    //   this.$emit(EVENT_DETAIL, owner.buildingId)
    // },
    //編集バータン
    handleEditAction(option) {
      this.$emit(EVENT_EDIT, option)
    },
    //削除バータン
    handleDeleteAction(option) {
      this.$emit(EVENT_DELETE, option)
    },
    sortData(key) {
      if(this.result != null && this.result.length > 0)
      if (this.sequence === "asc") {
        this.result.sort((a, b) => {
          return String(a[key]).localeCompare(
            String(b[key]),
            "ja-JP-u-ca-japanese-kf-upper"
          );
        });
        this.sequence = "desc";
      } else {
        this.result.sort((a, b) => {
          return String(b[key]).localeCompare(
            String(a[key]),
            "ja-JP-u-ca-japanese-kf-upper"
          );
        });
        this.sequence = "asc";
      }
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .my-button {
    width: 100% !important;
}

.btn-operate {
  margin: 0 5px 0 0;

  ::v-deep.my-button{
    width: 52px !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.btn-operate-other {
  margin-left: 5px;
}
.detailed-but::v-deep.my-button{
  width: 52px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
}
.text-center{
  display: flex;
}
</style>
